"use strict";

(function (a) {
    function _extends() { return _extends = Object.assign || function (a) { for (var b = 1; b < arguments.length; b++) { var c = arguments[b]; for (var d in c) Object.prototype.hasOwnProperty.call(c, d) && (a[d] = c[d]); } return a; }, _extends.apply(this, arguments); }

    var b = function params(a, c) {
        var d, e, f, g, h, i, j;
        var k = (a == null ? void 0 : a.data) instanceof Function ? a.data(b.dataDefaults) : (a == null ? void 0 : a.data) instanceof Object ? _extends({}, b.dataDefaults, (d = a == null ? void 0 : a.data) !== null && d !== void 0 ? d : {}) : (e = a == null ? void 0 : a.data) !== null && e !== void 0 ? e : b.dataDefaults;
        return _extends({}, b.defaults, a !== null && a !== void 0 ? a : {}, {
            type: c !== null && c !== void 0 ? c : (f = b.defaults) == null ? void 0 : f.type,
            data: ((g = b.defaults) == null ? void 0 : g.data) instanceof Function ? b.defaults.data(k) : ((h = b.defaults) == null ? void 0 : h.data) instanceof Object ? _extends({}, (i = (j = b.defaults) == null ? void 0 : j.data) !== null && i !== void 0 ? i : {}, k) : k !== null && k !== void 0 ? k : b.defaults.data
        });
    };

    b.post = function (a) {
        return b(a, "POST");
    }, b.get = function (a) {
        return b(a, "GET");
    }, b.put = function (a) {
        return b(a, "PUT");
    }, b["delete"] = function (a) {
        return b(a, "DELETE");
    }, b.defaults = {
        contentType: "application/json",
        data: function data(a) {
            return JSON.stringify(a);
        }
    }, b.dataDefaults = {}, a.params = b;
})(window);